import path from 'path'

export const CAD_EXTENSIONS = [
    '.3dm',
    '.3ds',
    '.3dxml',
    '.3mf',
    '.acs',
    '.arc',
    '.asm',
    '.catdrawing',
    '.catpart',
    '.catproduct',
    '.catshape',
    '.cgr',
    '.collada',
    '.dae',
    '.dlv',
    '.exp',
    '.gts',
    '.iam',
    '.ifc',
    '.ifczip',
    '.ipt',
    '.jt',
    '.mf1',
    '.model',
    '.neu',
    '.obj',
    '.off',
    '.par',
    '.pkg',
    '.ply',
    '.prc',
    '.prt',
    '.psm',
    '.pts',
    '.pwd',
    '.sab',
    '.sat',
    '.session',
    '.sldprt',
    '.step',
    '.stl',
    '.stp',
    '.tri',
    '.u3d',
    '.unv',
    '.v3d',
    '.vda',
    '.wrl',
    '.x3d',
    '.x3dv',
    '.x_b',
    '.x_t',
    '.xas',
    '.xmt',
    '.xmt_txt',
    '.xpr',
]

export const MESH_EXTENSIONS = [
    '.stl',
    '.3ds',
    '.collada',
    '.dae',
    '.obj',
    '.off',
    '.ply',
    '.v3d',
    '.pts',
    '.tri',
    '.asc',
    '.x3d',
    '.vrml',
]

// This includes both CAD and drawing extensions
export const ACCEPTABLE_IM_UPLOAD_EXTS = [
    '.3dm',
    '.3dxml',
    '.3mf',
    '.acs',
    '.arc',
    '.asm',
    '.catdrawing',
    '.catpart',
    '.catproduct',
    '.catshape',
    '.cgr',
    '.dlv',
    '.exp',
    '.gts',
    '.iam',
    '.ifc',
    '.ifczip',
    '.ipt',
    '.jt',
    '.mf1',
    '.model',
    '.neu',
    '.par',
    '.pkg',
    '.prc',
    '.prt',
    '.psm',
    '.pwd',
    '.sab',
    '.sat',
    '.session',
    '.sldprt',
    '.step',
    '.stp',
    '.u3d',
    '.unv',
    '.vda',
    '.wrl',
    '.x3dv',
    '.x_b',
    '.x_t',
    '.xas',
    '.xmt',
    '.xmt_txt',
    '.xpr',
    '.pdf',
]

export const CAD_EXTENSIONS_SET = new Set(CAD_EXTENSIONS)
const MESH_EXTENSIONS_SET = new Set(MESH_EXTENSIONS)

export function isMeshFileName(name) {
    const ext = path.extname(name).toLowerCase()

    return MESH_EXTENSIONS_SET.has(ext)
}

// it was used in src/components/FileUploader/index.jsx:360
// but it was commented for refactoring in 2020
// not sure if it's still relevant
// export function isNativeDrawingName(name) {
//     const ext = path.extname(name).toLowerCase()
//
//     return NATIVE_DRAWING_EXTENSIONS_SET.has(ext)
// }
